
namespace RioERP.Users {
    export class FranchiseeColumns {
        static columnsKey = 'Users.Franchisee';
    }
}